export * from '@fhs/routing/src/routes/(tabs)/rewards/_layout';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/_layout';
